/**
 * Created by José Rafael Gutierrez on 31/07/2020.
 */
import nextGeneral from '@/store/modules/next/general';

export default {
  nextGeneral,
};
